/* unplugin-vue-components disabled */import script from "./DetailDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailDialog.vue?vue&type=script&lang=ts&setup=true"

import "./DetailDialog.vue?vue&type=style&index=0&id=b93f1ffc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b93f1ffc"]])

export default __exports__